import Content from "../../help/label-settings.mdx";

export function LabelSettingsHelpPage() {
  return <Content />;
}
